import { For, Signal, createSignal } from "solid-js"
import './st-checkbox-list.css'

export interface Option {
  label: string
  value: string
}

export class STCheckboxListProps {
  options?: Option[]
  value?: Signal<string[]>
}
export default function STCheckboxList(props: STCheckboxListProps) {
  const [value, setValue] = props.value ?? createSignal([])

  const setOption = (option: Option, v: boolean) => {
    if (v && value().includes(option.value) === false) {
      setValue([...value(), option.value])
    } else if (!v && value().includes(option.value)) {
      setValue([
        ...value().slice(0, value().indexOf(option.value)),
        ...value().slice(value().indexOf(option.value) + 1),
      ])
    }
  }

  const toggleOption = (option: Option) => {
    setOption(option, !value().includes(option.value))
  }

  return (
    <div class="st-checkbox-list">
      <For each={props.options ?? []}>{option => (
        <label class="st-checkbox">
          <input type="checkbox" checked={value().includes(option.value)} onChange={() => toggleOption(option)}/>
          <span>{option.label}</span>
        </label>
      )}</For>
    </div>
  )
}

STCheckboxList.defaultProps = new STCheckboxListProps();